import { useState, useEffect, forwardRef } from "react";
import {
  Typography,
  Button,
  Slide,
  styled,
  Dialog,
  Box,
  Stack,
  Autocomplete,
  TextField,
} from "@mui/material";
import "./Notifications.css";
import Notification from "./notification/Notification"; 
import instance from "../../axios";
import CircularProgress from "@mui/material/CircularProgress";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel"; 
import NotificationModal from "./notification/modal/NotificationModal";


const statuses = [
  {
    id: 0,
    name: "Hammasi",
    isActive: true,
    number: null,
  },
  {
    id: 1,
    name: "Tasdiqlangan",
    isActive: false,
    number: 3,
  },
  {
    id: 2,
    name: "Bekor qilingan",
    isActive: false,
    number: 0,
  },
  {
    id: 3,
    name: "Kutilmoqda",
    isActive: false,
    number: 1,
  },
  {
    id: 4,
    name: "Jarayonda",
    isActive: false,
    number: 2,
  },
];

export default function Notifications() {
  const DialogWrapper = styled(Dialog)(
    () => `
        .MuiDialog-paper {
          overflow: visible;
        }
  `
  );
  const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
  });
  const [search, setSearch] = useState("");
  const [statusArr, setStatusArr] = useState(statuses || []);
  const [data, setData] = useState([]);
  const [masque, setMasque] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [arg, setArg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [, setError] = useState("");
  const [statusId, setStatusId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [ad_status, set_ad_status] = useState(0);
  // const tgId = window.Telegram.WebApp.initDataUnsafe.user.id
  const tgId = window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
    ? window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
    : "1598016165";
  const tgIdUser = window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
    ? window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
    : "1598016165";
  useEffect(() => {
    setIsLoading(true);
    let url =
      statusId | (statusId == 0)
        ? `api/reqs/results?admin_id=${tgIdUser}&status=${statusId}&search_query=${search}`
        : `api/reqs/results?admin_id=${tgIdUser}&search_query=${search}`;
    let query = ad_status != 0 ? `&ad_status=${ad_status}` : "";
    instance
      .get(url + query)
      .then((res) => {
        setData(res.data.data.requests);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [statusId, refresh, ad_status, search]);

  const handleSort = (id) => {
    const newStatusArr = statusArr.map((status) => {
      if (status.id === id) {
        status.isActive = true;
      } else {
        status.isActive = false;
      }
      return status;
    });
    setStatusArr(newStatusArr);
    // setShowModal(true)
  };
  const update = () => {
    setIsLoading(true);
    setModalShow(false);
    instance
      .put(
        `api/reqs/${masque?.id}`,
        { status: arg },
        { headers: { Authorization: `Telegram ${tgId}` } }
      )
      .then((res) => {
        setRefresh(!refresh);
        setMasque({ ...masque, status: arg });
        // setShowModal(false)
      })
      .catch((err) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <div className="container mx-auto p-2">
      {/* Top content */}
      <div>
        <h1 className="notifications__heading">Bildirishnomalar</h1>
        <Stack sx={{ background: "white", width: 300 }} my={2}>
          <Autocomplete
            size="small"
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={[
              ...new Set(
                data.map((el) => {
                  return el.ad.name;
                })
              ),
            ]?.map((option) => option)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Qidirish"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onSelect={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  size: "small",
                }}
              />
            )}
          />
        </Stack>
        <FormControl>
          <FormLabel>Statuslar</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            onChange={(e) => {
              set_ad_status(e.target.value);
            }}>
            <FormControlLabel value={0} control={<Radio />} label="Barchasi" />
            <FormControlLabel value={1} control={<Radio />} label="Aktiv" />
            <FormControlLabel value={2} control={<Radio />} label="Noaktiv" />
          </RadioGroup>
        </FormControl>
        <div className="notifications__nav">
          {statusArr.map((status) => (
            <span
              key={status.id}
              className={`notifications__nav__item ${
                status.isActive ? "notifications__nav__item--active" : ""
              }`}
              onClick={() => {
                handleSort(status.id);
                setStatusId(status.number);
              }}>
              {status.name}
            </span>
          ))}
        </div>
      </div>
      {isLoading ? (
        <div className="flex justify-center mt-10">
          <CircularProgress />
        </div>
      ) : (
        <>
          {showModal ? (
            <>
              {data.slice(0, 1).map((infoData) => (
                <Notification
                  key={infoData.id}
                  onClick={(qw) => {
                    setShowModal(true);
                    setMasque(qw);
                  }}
                  infoData={infoData}
                />
              ))}
            </>
          ) : (
            <>
              {[...new Set(data)].map((infoData) => (
                <Notification
                  key={infoData.id}
                  onClick={(qw) => {
                    setShowModal(true);
                    setMasque(qw);
                  }}
                  infoData={infoData}
                />
              ))}
            </>
          )}
        </>
      )}
      <NotificationModal
        showModal={showModal}
        setModalShow={setModalShow}
        isLoading={isLoading}
        statuses={statuses}
        masque={masque}
        setArg={setArg}
        setShowModal={setShowModal}
      />

      <DialogWrapper
        open={modalShow}
        maxWidth="sm"
        fullWidth
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          setModalShow(false);
        }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          p={5}>
          <Typography
            align="center"
            sx={{
              pt: 4,
              px: 6,
            }}
            variant="h3"
            style={{ fontSize: "30px" }}
            className="text-xs">
            Siz rostan ham statusni o`zgartirmoqchimisiz?
          </Typography>
          <Box mt={2}>
            <Button
              variant="text"
              size="large"
              sx={{
                mx: 1,
              }}
              onClick={() => {
                setModalShow(false);
              }}>
              Yo`q
            </Button>
            <Button
              onClick={() => {
                update();
              }}
              size="large"
              sx={{
                mx: 1,
                px: 3,
              }}
              variant="contained">
              Ha
            </Button>
          </Box>
        </Box>
      </DialogWrapper>
    </div>
  );
}
